import {
  ProtocolExplorerAccordionGroup,
  ProtocolExplorerFilterType,
  ProtocolExplorerSortingAccessor,
} from 'constants/protocolExplorerEnum';
import {SortDirectionType} from 'constants/dataEnum';
import * as ActionType from '../../constants/actionType';

const getDefaultExpandedGroups = () => {
  const defaultExpanded = {};

  Object.values(ProtocolExplorerAccordionGroup).forEach((cat) => {
    defaultExpanded[cat] = true;
  });

  return defaultExpanded;
};

const initialState = {
  protocolClipboardEventType: undefined,
  protocolClipboardItems: [],
  runningProtocol: null,
  currentProtocolFolder: null,
  expandedGroups: getDefaultExpandedGroups(),
  protocolFolderList: [],
  selectedProtocolOrFolderIDs: [],
  trayBoundProtocolIDs: [],
  defaultViewSettings: {},
  explorerItems: [],
  activeFilter: {
    type: ProtocolExplorerFilterType.ALL_ITEMS,
    value: null,
  },
  activeSort: {
    direction: SortDirectionType.ASC,
    accessor: ProtocolExplorerSortingAccessor.NAME,
  },
};

export default function protocolExplorerStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.RESET_PROTOCOL_EXPLORER_STATE:
      return initialState;
    case ActionType.SET_PROTOCOL_CLIPBOARD_EVENT_TYPE:
      return {
        ...state,
        protocolClipboardEventType: action.data,
      };
    case ActionType.SET_PROTOCOL_CLIPBOARD_ITEMS:
      return {
        ...state,
        protocolClipboardItems: action.data,
      };
    case ActionType.RESET_PROTOCOL_CLIPBOARD:
      return {
        ...state,
        protocolClipboardEventType: undefined,
        protocolClipboardItems: [],
      };
    case ActionType.SET_PROTOCOL_EXPLORER_RUNNING_PROTOCOL:
      return {
        ...state,
        runningProtocol: action.data,
      };
    case ActionType.SET_CURRENT_PROTOCOL_FOLDER:
      return {
        ...state,
        currentProtocolFolder: action.data,
      };
    case ActionType.SET_PROTOCOL_EXPLORER_EXPANDED_GROUPS:
      return {
        ...state,
        expandedGroups: {...state.expandedGroups, ...action.data},
      };
    case ActionType.SET_PROTOCOL_FOLDER_LIST:
      return {
        ...state,
        protocolFolderList: action.data,
      };
    case ActionType.SET_SELECTED_PROTOCOL_OR_FOLDER: {
      return {
        ...state,
        selectedProtocolOrFolderIDs: action.data,
      };
    }
    case ActionType.SET_DEFAULT_VIEW_SETTINGS: {
      return {
        ...state,
        defaultViewSettings: action.data,
      };
    }
    case ActionType.RESET_SELECTED_PROTOCOL_OR_FOLDER: {
      return {
        ...state,
        selectedProtocolOrFolderIDs: [],
      };
    }
    case ActionType.SET_PROTOCOL_EXPLORER_ITEMS: {
      return {
        ...state,
        explorerItems: action.items,
      };
    }
    case ActionType.SET_TRAY_BOUND_PROTOCOL_IDS: {
      return {
        ...state,
        trayBoundProtocolIDs: action.ids,
      };
    }
    case ActionType.SET_PROTOCOL_EXPLORER_FILTER: {
      return {
        ...state,
        activeFilter: action.filterObject,
      };
    }
    case ActionType.SET_PROTOCOL_EXPLORER_ACTIVE_SORT: {
      return {
        ...state,
        activeSort: action.sortObject,
      };
    }
    default:
      return state;
  }
}
